import styled from 'styled-components';
import LoaderBase from 'react-loading';

export const Container = styled.div`
  ${({ theme }) => theme.grid.pageContainer};
  width: 100%;
  margin-top: 90px;

  @media screen and (max-width: ${({ theme }) => theme.breakpoints.tabletPortrait}) {
    margin-top: 100px;
  }
`;

export const Title = styled.h1`
  ${({ theme }) => theme.fonts.DomaineDisplay};
  font-size: 36px;
  color: ${({ theme }) => theme.colors.night};

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.tabletPortrait}) {
    margin-bottom: 12px;
    font-size: 32px;
  }
`;

export const FlexContainer = styled.div`
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
`;

export const Description = styled.p`
  ${({ theme }) => theme.fonts.FoundersGrotesk};
  font-size: 16px;

  a {
    font-weight: bold;
  }
`;

export const Header = styled.div`
  max-width: 700px;
`;

export const SubTitle = styled.h2`
  ${({ theme }) => theme.fonts.DomaineDisplay};
  font-size: 26px;
  flex: 0 0 100%;
  margin-top: 20px;
  color: ${({ theme }) => theme.colors.night};
`;

export const Link = styled.a`
  text-decoration: underline;
`;

export const BoldText = styled.span`
  font-weight: 700;
`;

export const Loader = styled(LoaderBase).attrs(({ theme }) => ({
  type: 'spin',
  color: theme.colors.yellow,
  height: 150,
  width: 150
}))`
  margin: 120px auto auto auto;
`;

export const TotalBalanceAndPayButtonHolder = styled.div`
  display: flex;
`;
